// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a798505c","455":"b0292918","457":"1f3b468e"}[chunkId] + ".chunk.js";
};